import React, { useState } from 'react';
import { MdClose, MdPerson, MdEmail, MdPhone, MdSecurity } from 'react-icons/md';
import axios from 'axios';

const AddUserModal = ({ isOpen, onClose, showPopup, fetchData, API_BASE_URL, userMmdaId, user, onSuccess, onError }) => {
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    phone: '',
    countryCode: '+233',
    username: '',
    password: 'zxcv123$$', // Fixed password for field officers
    confirmPassword: 'zxcv123$$', // Fixed password for field officers
    role: 'Field Officer', // Fixed role for MMDA admins
  });
  const [loading, setLoading] = useState(false);

  const config = {
    headers: {
      'Authorization': 'Basic ' + btoa('Techland:Techland@24'),
      'Content-Type': 'application/json',
    },
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate passwords match
    if (formData.password !== formData.confirmPassword) {
      if (onError) {
        onError('Create', 'User', formData.full_name, 'Passwords do not match');
      } else {
        showPopup('Passwords do not match', 'error');
      }
      return;
    }

    // Validate password strength
    if (formData.password.length < 6) {
      if (onError) {
        onError('Create', 'User', formData.full_name, 'Password must be at least 6 characters long');
      } else {
        showPopup('Password must be at least 6 characters long', 'error');
      }
      return;
    }

    setLoading(true);

    try {
      // Combine country code with phone number for database storage
      const fullPhoneNumber = formData.phone ? `${formData.countryCode}${formData.phone}` : '';

      const userData = {
        full_name: formData.full_name,
        email: formData.email,
        phone: fullPhoneNumber, // Store the full phone number with country code
        username: formData.username,
        password: formData.password,
        role_id: 4, // Field Officer role ID from roles table
        mmda_id: userMmdaId,
        status: 'active',
        created_by: user?.user_id
      };

      const response = await axios.post(`${API_BASE_URL}/users`, userData, config);

      if (response.status === 201) {
        setFormData({
          full_name: '',
          email: '',
          phone: '',
          countryCode: '+233',
          username: '',
          password: 'zxcv123$$',
          confirmPassword: 'zxcv123$$',
          role: 'Field Officer',
        });
        onClose();
        
        // Show success modal
        if (onSuccess) {
          onSuccess('Created', 'Field Officer', formData.full_name, 'Field officer account has been successfully created and can now access the system.');
        } else {
          showPopup('Field officer created successfully!', 'success');
          fetchData();
        }
      }
    } catch (error) {

      
      // Show error modal
      if (onError) {
        onError('Create', 'Field Officer', formData.full_name, error.response?.data?.error || error.message);
      } else {
        showPopup(error.response?.data?.error || 'Failed to create field officer', 'error');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({
      full_name: '',
      email: '',
      phone: '',
      countryCode: '+233',
      username: '',
      password: 'zxcv123$$',
      confirmPassword: 'zxcv123$$',
      role: 'Field Officer',
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: 12,
        padding: 24,
        width: '90%',
        maxWidth: 500,
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 20,
          paddingBottom: 16,
          borderBottom: '1px solid #e0e0e0',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <MdPerson size={24} style={{ color: '#1976d2' }} />
            <h2 style={{ margin: 0, color: '#333', fontSize: 20 }}>Create Field Officer</h2>
          </div>
          <button
            onClick={handleClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 8,
              borderRadius: 4,
            }}
          >
            <MdClose size={24} style={{ color: '#666' }} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          {/* Personal Information */}
          <div style={{ marginBottom: 20 }}>
            <h3 style={{ margin: '0 0 16px 0', color: '#333', fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
              <MdPerson size={20} style={{ color: '#1976d2' }} />
              Personal Information
            </h3>
            
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4, fontWeight: 'bold', fontSize: 14 }}>
                Full Name *
              </label>
              <input
                type="text"
                name="full_name"
                value={formData.full_name}
                onChange={handleInputChange}
                required
                style={{
                  width: '95%',
                  padding: '10px 12px',
                  border: '1px solid #ddd',
                  borderRadius: 6,
                  fontSize: 14,
                  outline: 'none',
                }}
                placeholder="Enter full name"
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontWeight: 'bold', fontSize: 14 }}>
                  Email Address *
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '90%',
                    padding: '10px 12px',
                    border: '1px solid #ddd',
                    borderRadius: 6,
                    fontSize: 14,
                    outline: 'none',
                  }}
                  placeholder="officer@email.com"
                />
              </div>
 
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontWeight: 'bold', fontSize: 14 }}>
                  Phone Number *
                </label>
                <div style={{ display: 'flex', gap: 8 }}>
                  <select
                    name="countryCode"
                    value={formData.countryCode || '+233'}
                    onChange={handleInputChange}
                    style={{
                      width: '80px',
                      padding: '10px 8px',
                      border: '1px solid #ddd',
                      borderRadius: 6,
                      fontSize: 14,
                      outline: 'none',
                      backgroundColor: 'white',
                    }}
                  >
                    <option value="+233">🇬🇭 +233</option>
                    <option value="+234">🇳🇬 +234</option>
                    <option value="+1">🇺🇸 +1</option>
                    <option value="+44">🇬🇧 +44</option>
                    <option value="+27">🇿🇦 +27</option>
                  </select>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    style={{
                      flex: 1,
                      padding: '10px 12px',
                      border: '1px solid #ddd',
                      borderRadius: 6,
                      fontSize: 14,
                      outline: 'none',
                    }}
                    placeholder="241234567"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Account Information */}
          <div style={{ marginBottom: 20 }}>
            <h3 style={{ margin: '0 0 16px 0', color: '#333', fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
              <MdSecurity size={20} style={{ color: '#ff9800' }} />
              Account Information
            </h3>
            
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4, fontWeight: 'bold', fontSize: 14 }}>
 
              </label>
              <input
                type="hidden"
                name="username"
                value={formData.username}
                onChange={handleInputChange}
                required
                style={{
                  width: '95%',
                  padding: '10px 12px',
                  border: '1px solid #ddd',
                  borderRadius: 6,
                  fontSize: 14,
                  outline: 'none',
                }}
                placeholder="Enter username"
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontWeight: 'bold', fontSize: 14 }}>
                  Password *
                </label>
                <input
                  type="text"
                  name="password"
                  value={formData.password}
                  readOnly
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid #ddd',
                    borderRadius: 6,
                    fontSize: 14,
                    outline: 'none',
                    backgroundColor: '#f8f9fa',
                    color: '#666',
                    cursor: 'not-allowed',
                  }}
                />
              </div>
              
           
            </div>

            {/* Password Information */}
            <div style={{
              backgroundColor: '#fff3e0',
              padding: 12,
              borderRadius: 6,
              border: '1px solid #ffcc02',
              marginBottom: 16,
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                <MdSecurity size={16} style={{ color: '#f57c00' }} />
                <label style={{ fontSize: 12, color: '#f57c00', fontWeight: 'bold' }}>Default Password</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#f57c00', fontWeight: 'bold' }}>
                zxcv123$$
              </p>
              <p style={{ margin: '4px 0 0 0', fontSize: 11, color: '#f57c00' }}>
                All field officers are created with this default password. They can change it after first login.
              </p>
            </div>

            {/* Role Information */}
            <div style={{
              backgroundColor: '#e3f2fd',
              padding: 12,
              borderRadius: 6,
              border: '1px solid #bbdefb',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                <MdSecurity size={16} style={{ color: '#1976d2' }} />
                <label style={{ fontSize: 12, color: '#1976d2', fontWeight: 'bold' }}>Role</label>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#1976d2', fontWeight: 'bold' }}>
                Field Officer
              </p>
              <p style={{ margin: '4px 0 0 0', fontSize: 11, color: '#1976d2' }}>
                MMDA admins can only create Field Officer accounts
              </p>
            </div>
          </div>

          {/* Action Buttons */}
          <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 24 }}>
            <button
              type="button"
              onClick={handleClose}
              style={{
                padding: '10px 20px',
                border: '1px solid #6c757d',
                borderRadius: 6,
                backgroundColor: 'white',
                color: '#6c757d',
                cursor: 'pointer',
                fontSize: 14,
                fontWeight: 'bold',
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                padding: '10px 20px',
                border: 'none',
                borderRadius: 6,
                backgroundColor: loading ? '#6c757d' : '#1976d2',
                color: 'white',
                cursor: loading ? 'not-allowed' : 'pointer',
                fontSize: 14,
                fontWeight: 'bold',
              }}
            >
              {loading ? 'Creating...' : 'Create Field Officer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUserModal;
